<template>
  <v-bottom-sheet inset max-width="500px" v-model="sheet">
    <v-list>
      <v-subheader>{{ $t("components.camera.CameraBottomSheet.subheader") }} </v-subheader>
      <v-list-item
        @click="
          sheet = false;
          emitCamera();
        "
      >
        <v-list-item-icon>
          <v-icon>mdi-camera</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("components.camera.CameraBottomSheet.camera") }}</v-list-item-title>
      </v-list-item>
      <v-list-item
        @click="
          sheet = false;
          emitLibrary();
        "
      >
        <v-list-item-icon>
          <v-icon>mdi-file</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("components.camera.CameraBottomSheet.file") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-bottom-sheet>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class CameraBottomSheet extends Vue {
  /**
   * Emit functions.
   */
  public static EMITS = ["camera-clicked", "library-clicked"];

  /**
   * Display the sheet.
   */
  private sheet = false;

  /**
   * Open the sheet
   */
  public async open() {
    this.sheet = true;
  }

  /**
   * Close the sheet
   */
  public async close() {
    this.sheet = false;
  }

  /**
   * Emit camera-clicked event.
   */
  emitCamera() {
    this.$log.debug("emitCamera");
    this.$emit(CameraBottomSheet.EMITS[0]);
  }

  /**
   * Emit library-clicked event.
   */
  emitLibrary() {
    this.$log.debug("emitLibrary");
    this.$emit(CameraBottomSheet.EMITS[1]);
  }
}
</script>
